// extracted by mini-css-extract-plugin
export var avatarBone = "_d-4";
export var buttonBone = "_d-3";
export var continueBone = "_d-a";
export var frame = "_d-1";
export var logoBone = "_d-2";
export var pickerGrid = "_d-d";
export var pitchBone = "_d-9";
export var productBone = "_d-8";
export var sectionBone = "_d-7";
export var shell = "_d-0";
export var skeletonPulse = "_d-b";
export var subtitleBone = "_d-6";
export var titleBone = "_d-5";
export var viewport = "_d-c";